<template>
  <Transition @leave="onDestroy">
    <div class="el-overlay is-message-box" v-if="visiable">
      <div role="dialog" aria-modal="true" class="el-overlay-message-box">
        <div class="el-message-box discard-message-box" tabindex="-1">
          <div class="el-message-box__header">
            <div
              class="el-message-box__title"
              :style="center ? 'text-align:center' : ''"
            >
              {{ title }}
            </div>
            <div>
              <button
                type="button"
                class="el-message-box__headerbtn"
                aria-label="Close this dialog"
                @click="CloseClick"
              >
                <i class="el-icon el-message-box__close"><Close /></i>
              </button>
            </div>
          </div>
          <div class="el-message-box__content">
            <div class="el-message-box__container">
              <i class="el-icon"></i>
              <div
                class="el-message-box__message"
                :style="center ? 'text-align:center' : ''"
              >
                <p>{{ message }}</p>
              </div>
            </div>
          </div>
          <div class="el-message-box__btns">
            <button class="btn btn-primary" @click="onConfirm">
              {{ confirmButtonText }}
            </button>
            <button
              class="btn btn-discard"
              v-if="cancelButtonText !== ''"
              @click="CancelClick"
            >
              {{ cancelButtonText }}
            </button>
            <button class="btn" @click="CloseClick">
              {{ closeButtonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { Close } from '@element-plus/icons-vue';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  message: {
    type: String,
    default: '',
  },
  confirmButtonText: {
    type: String,
    default: 'OK',
  },
  cancelButtonText: {
    type: String,
    default: 'Cancel',
  },
  closeButtonText: {
    type: String,
    default: 'Close',
  },
  onOK: Function,
  onCancel: Function,
  onDestroy: Function,
  center: {
    type: Boolean,
    default: false,
    description: '居中显示',
  },
});

const promptContent = ref('');

const visible = ref(false);
// const confirmButtonText = ref(false);
// const cancelButtonText = ref(false);
const content = ref(false);
//const title = ref(false);

const onConfirm = (val) => {
  setVisiable(false);
  props.onOK('ok');
};

const CloseClick = (val) => {
  setVisiable(false);
  props.onCancel('close');
};

const CancelClick = (val) => {
  setVisiable(false);
  props.onCancel('cancel');
};

const visiable = ref(false);
const setVisiable = (value) => {
  visiable.value = value;
};

onMounted(() => {
  setVisiable(true);
});
</script>
<style scoped>
.discard-message-box {
  max-width: 533px;
}
.discard-message-box .el-message-box__btns button:not(:first-child) {
  margin-left: 10px;
}
.discard-message-box .btn.btn-discard,
.discard-message-box .btn.btn-discard:hover,
.discard-message-box .btn.btn-discard:focus,
.discard-message-box .btn.btn-discard:disabled .btn.active,
.discard-message-box .btn.btn-discard:not(:disabled):not(.disabled):active,
.discard-message-box .btn.btn-discard:not(:disabled):not(.disabled).active {
  background: #e56825 !important;
}
.v-enter-active .discard-message-box,
.v-leave-active .discard-message-box {
  transition: transform 0.3s cubic-bezier(0.23, 1, 0.32, 1),
    opacity 0.3s cubic-bezier(0.23, 1, 0.32, 1);
}

.v-enter-from .discard-message-box,
.v-leave-to .discard-message-box {
  opacity: 0;
  transform: translateY(-30px);
}
</style>
